var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "refresh",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.086,
    height: 150.086,
    viewBox: "0 0 150.086 150.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.107,
    x2: 0.489,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#520088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_18514",
    "data-name": "Path 18514",
    transform: "translate(0 0)",
    opacity: 0.933
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18514-2",
    "data-name": "Path 18514",
    d: "M75.043,0A75.043,75.043,0,1,1,0,75.043,75.043,75.043,0,0,1,75.043,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18514_-_Outline",
    "data-name": "Path 18514 - Outline",
    d: "M75.043,5.27A69.773,69.773,0,0,0,25.706,124.38,69.773,69.773,0,0,0,124.38,25.706,69.316,69.316,0,0,0,75.043,5.27m0-5.27A75.043,75.043,0,1,1,0,75.043,75.043,75.043,0,0,1,75.043,0Z",
    fill: "#ffd055"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19173",
    "data-name": "Path 19173",
    d: "M100.193,8.884H87.978V6.663A6.671,6.671,0,0,0,81.315,0H72.431a6.671,6.671,0,0,0-6.663,6.663V8.884H53.552A5.559,5.559,0,0,0,48,14.436V22.21a2.221,2.221,0,0,0,2.221,2.221h1.214l1.919,40.295a6.655,6.655,0,0,0,6.655,6.346H93.737a6.655,6.655,0,0,0,6.655-6.346l1.919-40.295h1.214a2.221,2.221,0,0,0,2.221-2.221V14.436A5.559,5.559,0,0,0,100.193,8.884ZM70.21,6.663a2.224,2.224,0,0,1,2.221-2.221h8.884a2.224,2.224,0,0,1,2.221,2.221V8.884H70.21ZM52.442,14.436a1.112,1.112,0,0,1,1.11-1.11h46.641a1.112,1.112,0,0,1,1.11,1.11v5.552H52.442ZM95.955,64.514a2.218,2.218,0,0,1-2.218,2.115H60.009a2.218,2.218,0,0,1-2.218-2.115L55.882,24.431H97.864Z",
    transform: "translate(-1.83 39.506)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19173_-_Outline",
    "data-name": "Path 19173 - Outline",
    d: "M73.071-.15h8.884A7.462,7.462,0,0,1,89.409,7.3V8.734h11.425a6.35,6.35,0,0,1,6.343,6.343V22.85a3.015,3.015,0,0,1-3.011,3.011h-.46L101.822,65.4a7.444,7.444,0,0,1-7.445,7.1H60.649A7.444,7.444,0,0,1,53.2,65.4L51.322,25.862h-.46A3.015,3.015,0,0,1,47.85,22.85V15.077a6.35,6.35,0,0,1,6.343-6.343H65.618V7.3A7.462,7.462,0,0,1,73.071-.15Zm31.094,24.431a1.432,1.432,0,0,0,1.43-1.431V15.077a4.767,4.767,0,0,0-4.762-4.762H87.828V7.3a5.879,5.879,0,0,0-5.872-5.872H73.071A5.879,5.879,0,0,0,67.2,7.3v3.011H54.193a4.767,4.767,0,0,0-4.762,4.762V22.85a1.432,1.432,0,0,0,1.431,1.431h1.968l1.955,41.048a5.865,5.865,0,0,0,5.866,5.593H94.377a5.865,5.865,0,0,0,5.866-5.593L102.2,24.281ZM73.071,4.292h8.884A3.015,3.015,0,0,1,84.967,7.3v3.011H70.06V7.3A3.015,3.015,0,0,1,73.071,4.292ZM83.386,8.734V7.3a1.432,1.432,0,0,0-1.431-1.431H73.071A1.432,1.432,0,0,0,71.641,7.3V8.734ZM54.193,13.176h46.641a1.9,1.9,0,0,1,1.9,1.9V21.42H52.292V15.077A1.9,1.9,0,0,1,54.193,13.176Zm46.961,6.663V15.077a.32.32,0,0,0-.32-.32H54.193a.32.32,0,0,0-.32.32v4.762Zm-45.46,4.442h43.64L97.385,65.192a3.008,3.008,0,0,1-3.008,2.868H60.649a3.008,3.008,0,0,1-3.008-2.868Zm41.982,1.581H57.351l1.869,39.255a1.429,1.429,0,0,0,1.429,1.363H94.377a1.429,1.429,0,0,0,1.429-1.363Z",
    transform: "translate(-2.47 38.865)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralDelete);
export default __webpack_public_path__ + "static/media/general-delete.f721d82cc811159e7bb46815e0ffda8f.svg";
export { ForwardRef as ReactComponent };